module.exports = __webpack_public_path__ + "img/Sibiu_1_kl.c896a365.jpg";